<div class="flex flex-col content pt-20 pr-26 pb-20 pl-26">
    <div class="flex flex-col w-100-percent">
    <div class="flex flex-row justify-between w-100-percent">
        <h1 class="flex flex-wrap mat-headline-5 mb-8 fw-600 fs-24 mr-98">{{value?.name | titlecase }}</h1>
        <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
    </div>
    <div class="flex flex-row w-100-percent items-center">
        <span class="flex flex-wrap mat-headline-5 mb-8 fw-400 fs-14 env-name">{{'SCHEDULE.ENVIRONMENT' | transloco }}&nbsp;{{instance}}</span>
        @if (value?.targets?.primary?.targetADOPipeline?.pipelineId) {
            <div class="flex flex-row justify-center items-center vertical-indicator h-16 ml-8 mr-8 fs-14 mb-8"></div>
           <a href="javascript:void(0);" (click)="openExternalLink(value?.targets?.primary?.targetADOPipeline?.pipelineId)" class="mb-8 flex items-center gap-1 ado-pipeline">
            <mat-icon svgIcon="open_in_new" class="icon-sm"></mat-icon>
            <span class="fw-400 fs-16">{{ 'ADD_INSTANCE.ADO_PIPELINE' | transloco }}</span>
          </a>
        }
    </div>
    </div>
    <mat-divider class="neutral-blue-7 w-100-percent mb-8"></mat-divider>
    <div class="flex flex-col environment_header mb-8">
        <div class="justify-between flex flex-row w-full mb-6">
            
        <div class="dynamic-grid">
            <div class="param-item">
                <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'RUNBOOK.RUNBOOK_NAME' | transloco | uppercase}}</div>
                <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ value?.name }}</div>
            </div>
            <div class="param-item">
                <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'RUNBOOK.VERSION' | transloco | uppercase}}</div>
                <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ value?.componentVersion }}</div>
            </div>
            <div class="param-item">
                <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'RUNBOOK.OPERATION' | transloco | uppercase}}</div>
                 <div *ngIf="isActionLoading; else actionLoaded">
            <ngx-skeleton-loader
                    appearance="line"
                    [theme]="{ height: '18px', width: '120px' }">
            </ngx-skeleton-loader>
        </div>
                 <ng-template #actionLoaded>
    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">
      {{ action }}
    </div>
  </ng-template>
            </div>
        </div>
        </div>
    </div>
    <div class="flex flex-col environment_header mb-8">
        <div class="flex flex-row">
              <div class="basis-full heading fs-16 fw-700 mb-12">{{ 'INSTANCE_DETAILS.PARAMETERS' | transloco }}</div>
        </div>
        <div class="dynamic-grid" *ngIf="dynamicParams">
            <div class="param-item" *ngFor="let item of dynamicParams">
                <div class="overline-font subheading fs-14 fw-700 mb-8">{{ item.key | uppercase }}</div>
            <div *ngIf="isActionLoading; else actionLoaded">
                        <ngx-skeleton-loader
                            appearance="line"
                            [theme]="{ height: '18px', width: '120px' }">
                        </ngx-skeleton-loader>
                    </div>
                 <ng-template #actionLoaded>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ getValue(item.value) }}</div>
                 </ng-template>
            </div>
        </div>
    </div>
</div>